module.exports = __webpack_public_path__ + "img/a.72ed7e81.jpg";